:host{display:flex;flex-direction:column;height:100%}
/*# sourceMappingURL=admin-panel-company-user-list.component-OV4BFBIB.css.map */
